(() => {
  const addExpectedAvailability = () => {
    const text = window.__aw26ExpectedAvailability;
    if (!text) return;

    const form = document.querySelector('#formContainer');
    if (!form) return;

    const description = form.querySelector('#form-Description');
    if (!description) return;
    const modalDescription = 'Get a notification as soon as this product is available.';
    if (description.textContent?.trim() !== modalDescription) {
      description.textContent = modalDescription;
    }
    if (form.querySelector('[data-aw26-expected-availability]')) return;

    const note = document.createElement('p');
    note.dataset.aw26ExpectedAvailability = 'true';
    note.textContent = text;
    note.style.cssText = 'margin: 12px 0 0; font-weight: 600; color: inherit;';
    description.insertAdjacentElement('afterend', note);
  };

  const normalizeCartShipping = () => {
    document.querySelectorAll('.drawerProductTitle > span:not([class])').forEach((line) => {
      const match = line.textContent?.trim().match(/^Shipping:\s*(.+)$/i);
      if (match) line.textContent = 'Estimated shipping date: ' + match[1];
    });
  };

  const refresh = () => {
    addExpectedAvailability();
    normalizeCartShipping();
  };

  document.addEventListener('DOMContentLoaded', refresh);
  let refreshQueued = false;
  new MutationObserver(() => {
    if (refreshQueued) return;
    refreshQueued = true;
    window.setTimeout(() => {
      refreshQueued = false;
      refresh();
    }, 50);
  }).observe(document.body, {
    childList: true,
    subtree: true,
  });
  refresh();
})();
